define([
    "jquery",
    "underscore",
    "backbone",
    "moment",
    "utils/localstorage"
    ], function($, _, Backbone, moment, LocalStorage) {
        "use strict";

        var OrderModel = Backbone.NestedModel.extend({
            url: function() {
                return App.urlTo("shop/shop/add-address");
            },

            defaults: {
                _csrf            : App.Constants.CSRF_TOKEN,
                shipment_address : {},
                invoice_address  : {},
                creditCardId     : null
            },

            initialize: function() {},

            calculateSubtotal: function() {
                var subtotal = 0;
                _.each(this.get("lines"), function(order_line) {
                    subtotal = subtotal + order_line.units * order_line.priceWithoutFormat;
                });

                this.set("subtotal", subtotal);
                return subtotal;
            },

            calculateTaxes: function() {
                var total = 0,
                    subtotal = this.calculateSubtotal();

                _.each(this.get("lines"), function(order_line) {
                    total = total + App.parseFloat(order_line.total);
                });

                this.set("tax", App.parseFloat(total - subtotal));
                this.set("total", App.parseFloat(total));
            },

            tempSave: function() {
                LocalStorage.save("ParkingDoor:shop:cart", this.toJSON(), moment().add(7, "days").utc().format());
            },

            tempLoad: function() {
                this.set(LocalStorage.get("ParkingDoor:shop:cart"));
                this.calculateTaxes();
                return this;
            },

            hasCreditCard: function() {
                return this.get("creditCardId") != null;
            },

            getPayUrl: function() {
                return App.urlTo("shop/shop/pay", {
                    orderId : this.get("id"),
                    creditCardId : this.get("creditCardId")
                });
            },

            cancel: function(functions) {
                var url = App.urlTo("order/cancel", { id : this.get("id") });
                this.save({}, {
                    success   : functions.success,
                    error     : functions.error,
                    url       : url
                });
            }

        });

        return OrderModel;

    });
